import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, PanelGroup, Panel } from "react-bootstrap";
import * as UserActionType from "../constants";
import "../faq-modal.scss";

export class FAQModalHO extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    errorMsg: PropTypes.array,
    item: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: "",
      faqData: [], 
    };
  }

  componentDidMount() {
    this.getAllfaq();
  }

  getAllfaq = () => {
    this.props.dispatch({
      type: UserActionType.GET_ALL_FAQ_ASYNC,
      callback: (data) => {
        this.setState({ faqData: data.data });
      },
    });
  };

  handleSelect = (activeKey) => {
    this.setState({
      activeKey: this.state.activeKey === activeKey ? null : activeKey,
    });
  };

  renderStep = (step, level = 1) => {
    return (
      <div
        key={step.id}
        className={`faq-step faq-level-${level}`}
        style={{ marginLeft: level * 12 }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
          <div style={{ width: "10px", height: "10px" }}>
            <div className="faq-bullet" />
          </div>
          <span>{step.content}</span>
        </div>

        {step.subSteps && step.subSteps.length > 0 && (
          <div className="faq-substeps">
            {step.subSteps.map((sub) => this.renderStep(sub, level + 1))}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { faqData, activeKey } = this.state;

    return (
      <Modal
        show={isOpen}
        onHide={closeModal}
        backdrop="static"
        dialogClassName="slide-in-modal"
        className="modal-right"
      >
        <Modal.Header className="modal-header-profile">
          <div className="modal-header">
            <i
              className="fa fa-chevron-left arrow-btn"
              onClick={closeModal}
            ></i>
            <Modal.Title className="modal-title-custom">FAQ</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="modal-body-profile">
          <PanelGroup
            accordion
            id="faq-accordion"
            activeKey={activeKey}
            onSelect={this.handleSelect}
          >
            {faqData && faqData.length > 0 ? (
              faqData.map((faq, index) => (
                <Panel eventKey={faq.id} key={faq.id}>
                  <Panel.Heading>
                    <Panel.Title toggle>
                      <div className="faq-panel-title">
                        {faq.title}
                        {activeKey === faq.id ? (
                          <i className="fa fa-chevron-up faq-arrow" />
                        ) : (
                          <i className="fa fa-chevron-down faq-arrow" />
                        )}
                      </div>
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible>
                    {faq.intro && (
                      <p>
                        <strong>{faq.intro}</strong>
                      </p>
                    )}
                    {faq.steps &&
                      faq.steps.map((step) => this.renderStep(step))}
                  </Panel.Body>
                </Panel>
              ))
            ) : (
              <div>No FAQs available.</div>
            )}
          </PanelGroup>
        </Modal.Body>
      </Modal>
    );
  }
}

export default FAQModalHO;



// WEBPACK FOOTER //
// ./src/User/Components/FAQ-myaccount.js